import React, {useEffect, useState} from 'react';
import MainLayout from "../layouts/main";
import HelperService from "../services/helper-service";
import Section from "../components/section";
import {useArticleService} from "../services/article-service";
import {useManagerService} from "../services/manager-service";
import {useGlobalNotificationMessage} from "../context/message";
import Manager from "../components/buildings/manager";
import Loading from "../components/loading";
import ArticlesBox from "../components/articles/articles-box";

export default function Dashboard () {

    const articleService = useArticleService();
    const managerService = useManagerService();

    const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
    const [articles, setArticles] = useState([]);
    const [loadedArticles, setLoadedArticles] = useState(false);
    const [loadedManagers, setLoadedManagers] = useState(false);
    const [managers, setManagers] = useState(null);

    useEffect(() => {
        reloadArticles();
        reloadManagers();
    }, []);

    function reloadArticles(){
        articleService.getPublished()
            .then((rows)=>{
                setArticles(rows);
                setLoadedArticles(true);
            })
            .catch(error => {
                HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
            })
    }

    function reloadManagers(){
        managerService.getMembership()
            .then((rows)=>{
                setManagers(rows);
                setLoadedManagers(true);
            })
            .catch(error => {
                HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
            })
    }

    return (
        <>
            <Section animation={HelperService.getRandomAnimation()}>
                <div className="container">

                    <div className="row">
                        <div className="col-sm-12">

                            {/*<div className="d-flex align-items-center justify-content-between mb-2">*/}
                            {/*  <PageTitle>Domov</PageTitle>*/}
                            {/*</div>*/}

                            <Section animation={HelperService.getRandomAnimation()}>
                                <h2>Novinky</h2>
                                {!loadedArticles && <Loading />}
                                {loadedArticles && <ArticlesBox articles={articles} max={3} />}
                            </Section>

                            <Section animation={HelperService.getRandomAnimation()}>
                                <h2>Správcovia</h2>
                                <div className="col-12 mb-4">
                                    <div className="row">
                                        {!loadedManagers && <Loading />}
                                        {loadedManagers && <>
                                            {!managers.length>0 && <div className="card">
                                                <div className="card-body">
                                                    <p className="text-muted">Zatiaľ prázdne :)</p>
                                                </div>
                                            </div>}
                                            {managers.length>0 && managers.map((man, i)=>{
                                                return <div key={man.id} className={`col-sm-12 col-md-6 col-lg-4`}><Manager manager={man} className={i===1 ? 'bg-success text-white' : null} /></div>;
                                            })}
                                        </>}
                                    </div>
                                </div>
                            </Section>

                        </div>
                    </div>

                </div>
            </Section>
        </>
    );
}

Dashboard.getLayout = function getLayout(page) {
    return (
        <MainLayout>
            {page}
        </MainLayout>
    )
}

Dashboard.getSEO = function getSEO() {
    return {
        title: "Domov",
    }
}
